import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    language: 'de',
    breaks: [
      {
        id: 1,
        headline: 'Linker Einzug',
        description:
          'Im Buchsatz ist der linke Einzug die Norm. Die Größe des Einzugs variiert, liegt in der Regel aber bei ungefähr einem Geviert.',
        illustration: 'left-indentation.svg',
        css: 'left-indentation'
      },
      {
        id: 2,
        headline: 'Horizontaler Abstand',
        description:
          'Der Standard in der Web-Gestaltung. Absätze werden durch eine Leerzeile getrennt. Die einzelnen Absätze beginnen dabei in der Regel stumpf. Im Buchsatz wird der horizontale Abstand meist genutzt, um einen neuen Abschnitt zu markieren.',
        illustration: 'horizontal-spacing.svg',
        css: 'horizontal-spacing'
      },
      {
        id: 3,
        headline: 'Weiße Binnenfläche',
        description:
          'Der Standard in der Web-Gestaltung. Absätze werden durch eine Leerzeile getrennt. Die einzelnen Absätze beginnen dabei in der Regel stumpf. Im Buchsatz wird der horizontale Einzug meist genutzt, um einen neuen Abschnitt zu markieren.',
        illustration: 'inline-spacing.svg',
        css: 'inline-spacing'
      },
      {
        id: 4,
        headline: 'Variabler Einzug',
        description:
          'Eine Variante des gewohnten linken Einzuges. Anstatt eines festen Wertes orientiert sich der Einzug an einer Zeile an der vorangegangenen Zeile',
        illustration: 'floating-indentation.svg',
        css: 'floating',
        floating: true
      }
    ],
    preview: {
      isOpen: false,
      layout: {
        css: '',
        floating: false
      },
      de: {
        text:
          '<p>Hoch über der Stadt, auf einer hohen Säule, stand die Statue des glücklichen Prinzen.Er war ganz und gar vergoldet mit dünnen Blättern feinsten Goldes und hatte als Augen zwei helle Saphire und ein großer roter Rubin leuchtete am Ende auf seinem Schwertgriff.</p><p>Er wurde in der Tat sehr bewundert. «Er ist so schön wie ein Wetterhahn», bemerkte einer der Stadträte, der sich wünschte für seinen künstlerischen Geschmack bekannt zu sein, «nur nicht ganz so nützlich», fügte er hinzu, fürchtete er doch die Leute dächten er wäre zu weltfremd in seiner Denkweise, was er zweifelsohne nicht war.</p><p> «Warum bist du nicht so wie der glückliche Prinz?», fragte eine empfindsame Mutter ihren Sohn, der stets verträumt zum Mond sah. Der glückliche Prinz weint niemals vor Verlangen nach irgendetwas». «Ich bin so froh, dass es in dieser Welt wenigstens einen gibt, der wirklich glücklich ist», flüsterte ein nachdenklicher und von der Welt enttäuschter Mann, als er zu der wunderbaren Statue empor schaute. «Er gleicht einem Engel», riefen die Waisenkinder, als sie in ihren weiten roten Umhängen und ihren sauberen weißen Kleidern aus der Kathedrale kamen. «Woher wisst ihr das?», raunte der Mathematiklehrer, «ihr habt doch noch nie einen Engel gesehen». «Ach, das haben wir, in unseren Träumen», antworteten die Kinder, und der Lehrer schaute ärgerlich und streng vor sich hin, denn er mochte es gar nicht, wenn Kinder träumten.</p>',
        credit: 'Oscar Wilde – Der glückliche Prinz'
      }
    }
  },
  getters: {
    previewLayout: ({ preview }) => preview.layout
  },
  mutations: {
    togglePreview: ({ preview }, direction = undefined) => {
      if (direction !== undefined) {
        preview.isOpen = direction
      } else {
        preview.isOpen = !preview.isOpen
      }
    },
    previewLayout: ({ preview }, infos) => {
      preview.layout.css = infos.css
      preview.layout.floating = infos.floating
    }
  },
  actions: {
    OPEN_PREVIEW: ({ commit, dispatch }, id) => {
      commit('togglePreview', true)
      dispatch('UPDATE_PREVIEW', id)
    },
    UPDATE_PREVIEW: ({ state, commit }, id) => {
      const { css, floating } = state.breaks.find(k => id === k.id)
      commit('previewLayout', { css, floating })
    }
  }
})
